export default __webpack_public_path__ + "static/media/Snakeswift Padsoles.4114dda1.jpg";